// import { Dispatch, Action } from 'redux'
// import { createSubmitAction } from 'actionCreators/submit/Submit/createSubmitAction'
// import { SUBMIT_DELETE_TASK_TAG } from 'actions'

import {
  // TeamNameWidgetConnectedProps,
  TeamNameWidgetMapDispatchReturnType,
} from './types'

export const TeamNameWidgetMapDispatch = (
  // dispatch: Dispatch<Action>,
  // props: TeamNameWidgetConnectedProps,
): TeamNameWidgetMapDispatchReturnType => {
  return {
  }
}
